/* NIBBLE & NABBLE — Variant Picker (editor-safe) */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function initPicker(root) {
    if (!root || root.dataset.vpInit === '1') return;
    root.dataset.vpInit = '1';

    var variants;
    try {
      var raw = root.dataset.variants
        .replace(/&quot;/g, '"').replace(/&#34;/g, '"')
        .replace(/&amp;/g, '&').replace(/&#39;/g, "'");
      variants = JSON.parse(raw);
    } catch (e) { variants = []; }
    if (!variants.length) return;

    var scope = root.parentElement || document;
    var hiddenIds = scope.querySelectorAll('[data-nn-variant-id]');
    var priceEl = document.querySelector('[data-product-price], .nn-product__price');
    var stickyPriceEl = document.querySelector('#nn-sticky-atc .nn-sticky-atc__price');
    var atcBtns = document.querySelectorAll('.nn-product__atc button[name="add"], #nn-sticky-atc button');

    function currentSelections() {
      return Array.prototype.map.call(
        root.querySelectorAll('input[type="radio"]:checked'),
        function (r) { return r.value; }
      );
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function markAvailability() {
      var sel = currentSelections();
      root.querySelectorAll('input[type="radio"]').forEach(function (r) {
        var idx = parseInt(r.dataset.optionIndex, 10);
        var testSel = sel.slice();
        testSel[idx] = r.value;
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === testSel[i]; });
        });
        var choice = r.closest('.nn-vp__choice');
        if (!choice) return;
        choice.classList.toggle('nn-vp__choice--soldout', match !== undefined && !match.available);
        choice.classList.toggle('nn-vp__choice--unavailable', match === undefined);
      });
    }

    function updateLegends() {
      root.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        var idx = r.dataset.optionIndex;
        var label = root.querySelector('[data-selected-for="' + idx + '"]');
        if (label) label.textContent = r.value;
      });
    }

    function bloomSelectedPill() {
      if (reduced) return;
      root.querySelectorAll('input[type="radio"]:checked + .nn-vp__pill').forEach(function (pill) {
        pill.classList.remove('nn-vp__pill--bloom');
        // Force reflow so the animation can restart
        void pill.offsetWidth;
        pill.classList.add('nn-vp__pill--bloom');
      });
    }

    function apply(fromUser) {
      updateLegends();
      markAvailability();
      var v = findVariant(currentSelections());
      if (!v) return;

      if (hiddenIds) hiddenIds.forEach(function (el) { el.value = v.id; });

      if (priceEl) {
        var strikeHtml = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          strikeHtml = ' <s style="color:var(--nn-mid);font-size:var(--text-lg);font-weight:400;margin-left:8px;">' + money(v.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = money(v.price) + strikeHtml;
      }
      if (stickyPriceEl) stickyPriceEl.textContent = money(v.price);

      atcBtns.forEach(function (btn) {
        if (v.available) {
          btn.disabled = false;
          if (btn.dataset.originalLabel) { btn.textContent = btn.dataset.originalLabel; delete btn.dataset.originalLabel; }
        } else {
          if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent;
          btn.textContent = 'Sold Out';
          btn.disabled = true;
        }
      });

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* older browsers, skip */ }
      }

      if (fromUser) bloomSelectedPill();
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') apply(true);
    });

    // Set state from ?variant= if present
    try {
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant) {
        var target = variants.find(function (v) { return String(v.id) === String(urlVariant); });
        if (target) {
          target.options.forEach(function (val, i) {
            var input = root.querySelector('input[data-option-index="' + i + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
            if (input) input.checked = true;
          });
        }
      }
    } catch (e) { /* URLSearchParams unsupported, skip */ }

    apply(false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nn-variant-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nn-variant-picker]').forEach(function (el) { el.dataset.vpInit = ''; });
    initAll(e.target);
  });
})();
